module.exports = __webpack_public_path__ + "media/assets/fonts/NeueHaasGrotesk-Regular-a4c6f6d97398d8f9a96c4b0e69d6099e.ttf";